export default "__VITE_ASSET__DxwrQp6z__"